// extracted by mini-css-extract-plugin
export var awards = "Awards-module--awards--a6tq8";
export var content = "Awards-module--content--uZ+ji";
export var teaser = "Awards-module--teaser--pCJGw";